// extracted by mini-css-extract-plugin
module.exports = {"content":"Loading_content__1lEAR","loader":"Loading_loader__5s6Kt"};